module.exports = __webpack_public_path__ + "assets/monitor.png?b11fa7a5c3e8eb3a21ec6cfacff54cb2";